/* Common constant variables for rax */

export const INTERNAL = '_internal';
export const INSTANCE = '_instance';
export const NATIVE_NODE = '_nativeNode';
export const RENDERED_COMPONENT = '_renderedComponent';
